/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useState } from 'react';
import { cssMap, jsx } from '@compiled/react';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import SwitcherItemWithDropdown from '../../primitives/item-with-dropdown';

export interface OverflowSectionProps {}

const styles = cssMap({
	iconWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '32px',
		width: '32px',
	},
});

const OverflowSection = ({}: OverflowSectionProps) => {
	const [isMore, setIsMore] = useState(true);
	const buttonText = isMore ? 'More' : 'Less';

	const onClick = () => {
		setIsMore(!isMore);
	};

	const icon = (
		<div css={styles.iconWrapper}>
			<ShowMoreHorizontalIcon label={`${buttonText} icon`} />
		</div>
	);
	return (
		<SwitcherItemWithDropdown
			icon={icon}
			children={buttonText}
			productName={undefined}
			onItemClick={onClick}
		/>
	);
};

export default OverflowSection;
